import { render, staticRenderFns } from "./AVDevicePrompt.vue?vue&type=template&id=2c20aea6&lang=pug&"
import script from "./AVDevicePrompt.vue?vue&type=script&lang=js&"
export * from "./AVDevicePrompt.vue?vue&type=script&lang=js&"
import style0 from "./AVDevicePrompt.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports